export default __webpack_public_path__ + "static/media/back.ad22f433.png";